<div class="box mx-auto">
    <div class="relative">
        <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            width="216.1px"
            height="188.4px"
            viewBox="0 0 216.1 188.4"
            enable-background="new 0 0 216.1 188.4"
            xml:space="preserve"
        >
            <path
                fill="none"
                class="dark"
                stroke-width="12"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="14"
                d="
        M 177.5, 181.4
        c 19.4-18.4, 31.5-44.5, 31.5-73.3
        c 0-55.8-45.2-101-101-101
        S 7,52.2,7,108
        c 0,28.9,12.1,54.9,31.5,73.3"
            ></path>
            <path
                fill="none"
                attr.class="{{ class }}"
                attr.stroke-dasharray="{{ stroke }}, 482"
                stroke-width="12"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="14"
                d="
        M 177.5, 181.4
        c 19.4-18.4, 31.5-44.5, 31.5-73.3
        c 0-55.8-45.2-101-101-101
        S 7,52.2,7,108
        c 0,28.9,12.1,54.9,31.5,73.3"
            ></path>
        </svg>

        <div class="inner text-center">
            <div class="text-muted text-xxs mb-1 text-line-1" translate>v3-preview-current</div>
            <div class="text-default text-line-1 text-oneline" [ngClass]="[current >= 3600 ? 'text-xl mb-5' : 'text-xxl mb-4']" translate>
                {{ current | time: { type: 'letter', round: 'down' } }}
            </div>
            <div [class]="'text-xxs font-semi-bold text-default text-line-1 widget-goal-text widget-goal-text-' + currentLanguage">
                {{ declarated | time: { type: 'letter' } }} {{ 'v3-preview-goal' | translate }}
            </div>
        </div>
    </div>
</div>
